<template>
  <div class="task-body">
    <!--    add task layout-->
    <template v-if="!form.id">
      <b-tabs class="mb-0" v-model="taskTab">
        <b-tab-item label="Task Form" value="form" class="pt-75">
          <grid-row>
            <grid-column>
              <form-field-select
                label="Templates"
                @change="setTemplateData"
              >
                <option v-if="loadingTemplates" :value="null" disabled>Loading...</option>
                <option v-else :value="null">No Template Selected</option>
                <option v-for="template in templates" :key="template.id" :value="template">{{template.label}} - {{ getAssignedUser(template) }}</option>
              </form-field-select>
            </grid-column>
          </grid-row>

          <grid-row>
            <grid-column>
              <form-field-input
                label="Task"
                v-model="form.label"
                :validation-errors="validationErrors.label"
              ></form-field-input>

              <form-field-textarea
                label="Description"
                v-model="form.description"
                :validation-errors="validationErrors.description"
              ></form-field-textarea>

              <form-field-input
                label="Task Link"
                v-model="form.link"
                :validation-errors="validationErrors.link"
                help-text="Link to video or docs on how to do the task"
              ></form-field-input>

              <form-field-select-users
                label="Assigned To"
                v-model="form.assigned_to_id"
                :validation-errors="validationErrors.assigned_to_id"
                :has-empty-option="true"
              ></form-field-select-users>

              <form-field-switch
                label="Is Required To Change Status"
                v-model="form.is_required_to_change_status"
                :validation-errors="validationErrors.is_required_to_change_status"
                description="Should this task be required to be completed in order to change the status of a Lead?"
              ></form-field-switch>

<!--              <form-field-switch-->
<!--                label="Update Lead Status Change Date"-->
<!--                v-model="form.set_due_at"-->
<!--                :validation-errors="validationErrors.set_due_at"-->
<!--                description="This will set the Lead Status Change Date (when lead will go red) to this task date"-->
<!--              ></form-field-switch>-->
            </grid-column>

            <grid-column>
              <form-field-collection
                label="Tags"
                v-model="form.tags"
                :options="availableTags"
                field="label"
                placeholder="Select tag"
                icon="label"
                type="is-info"
                :validation-errors="validationErrors.tags"
              ></form-field-collection>

              <form-field-datetime-picker
                label="Due At"
                v-model="form.due_at"
                is-inline
              ></form-field-datetime-picker>
              <form-validation-errors
                :validation-errors="validationErrors.due_at"
                is-inline
              ></form-validation-errors>
            </grid-column>
          </grid-row>
        </b-tab-item>

        <b-tab-item label="Choose From The List" value="list" class="pt-75">
          <grid-row>
            <grid-column>
              <form-field-select
                label="List"
                v-model="selectedList"
                :validation-errors="validationErrors.list_id"
              >
                <option v-if="loadingList" :value="null" disabled>Loading...</option>
                <option v-else :value="null">No List Selected</option>
                <option v-for="list in lists" :key="list.id" :value="list">{{ list.label }} - {{ list.task_templates.length }} task templates</option>
              </form-field-select>

              <div class="task-list" v-show="selectedListTemplates">
                <ol >
                  <li class="task-list--body"
                    v-for="template in selectedListTemplates"
                    :key="template.id"
                  >
                    <h5 class="task-list--heading">{{ template.label }} <span>- {{ getAssignedUser(template) }}</span></h5>
                    <p class="task-list--desc">{{ template.description }}</p>
                  </li>
                </ol>
              </div>
            </grid-column>
          </grid-row>
        </b-tab-item>
      </b-tabs>
    </template>

    <!--    edit task layout-->
    <template v-else>
      <grid-row>
        <grid-column>
          <form-field-input
            label="Task"
            v-model="form.label"
            :validation-errors="validationErrors.label"
          ></form-field-input>

          <form-field-textarea
            label="Description"
            v-model="form.description"
            :validation-errors="validationErrors.description"
          ></form-field-textarea>

          <form-field-input
            label="Task Link"
            v-model="form.link"
            :validation-errors="validationErrors.link"
            help-text="Link to video or docs on how to do the task"
          ></form-field-input>

          <form-field-select-users
            label="Assigned To"
            v-model="form.assigned_to_id"
            :validation-errors="validationErrors.assigned_to_id"
            :has-empty-option="true"
          ></form-field-select-users>

          <form-field-switch
            label="Is Required To Change Status"
            v-model="form.is_required_to_change_status"
            :validation-errors="validationErrors.is_required_to_change_status"
            description="Should this task be required to be completed in order to change the status of a Lead?"
          ></form-field-switch>

<!--          <form-field-switch-->
<!--            label="Update Lead Status Change Date"-->
<!--            v-model="form.set_due_at"-->
<!--            :validation-errors="validationErrors.set_due_at"-->
<!--            description="This will set the Lead Status Change Date (when lead will go red) to this task date"-->
<!--          ></form-field-switch>-->
        </grid-column>

        <grid-column>
          <form-field-collection
            label="Tags"
            v-model="form.tags"
            :options="availableTags"
            field="label"
            placeholder="Select tag"
            icon="label"
            type="is-info"
            :validation-errors="validationErrors.tags"
          ></form-field-collection>

          <form-field-datetime-picker
            label="Due At"
            v-model="form.due_at"
            is-inline
          ></form-field-datetime-picker>
          <form-validation-errors
            :validation-errors="validationErrors.due_at"
            is-inline
          ></form-validation-errors>
        </grid-column>
      </grid-row>
    </template>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import FormValidationErrors from "../components/form/FormValidationErrors";
  import dates from "../services/dates";
  import api from "../api";
  import TaskTemplateForm from "../modules/settings/components/edit-status/TaskTemplateForm.vue";
  import {ENUMS} from "../services/enums";

  export default {
    name: "TaskForm",
    components: {TaskTemplateForm, FormValidationErrors},
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        taskTab: 'form',
        templates: [],
        loadingTemplates: true,
        selectedList: null,
        lists: [],
        loadingList: true,
        defaultForm: {
          id: null,
          record_id: this.$store.state.activeRecord ? this.$store.state.activeRecord.record.id : null,
          assigned_to_id: null,
          label: '',
          description: '',
          due_at: dates.getTomorrowJSDate(16, 0),
          is_required_to_change_status: false,
          set_due_at: false,
          tags: [],
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    mounted() {
      this.loadTemplates().then(() => {
        this.loadList()
      })
    },
    computed: {
      record() {
        // If activeRecord is null then return necessary empty info
        return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : null;
      },
      availableTags() {
        return this.$store.getters.taskTags;
      },
      users() {
        return this.$store.getters.activeUsers
      },
      selectedListTemplates() {
        if (this.selectedList === null) return []

        const list = this.lists.find(list => list.id === this.selectedList.id)
        return (list) ? list.task_templates : []
      }
    },
    methods: {
      getAssignedUser(taskTemplate) {
        const user = this.users.find(u => u.id === taskTemplate.assign_to_id)
        return (user) ? user.full_name : 'No User Assigned'
      },
      setTemplateData(template) {
        let assignedTo = template.assign_to_id;
        if (template.user_role && this.record) {
          if (template.user_role === ENUMS.UserRoleEnum.LeadManager.value) {
            if (this.record.lead_manager_id) {
              assignedTo = this.record.lead_manager_id;
            }
          }
          if (template.user_role === ENUMS.UserRoleEnum.AcquisitionsManager.value) {
            if (this.record.acquisitions_manager_id) {
              assignedTo = this.record.acquisitions_manager_id;
            }
          }
          if (template.user_role === ENUMS.UserRoleEnum.DispositionsManager.value) {
            if (this.record.dispositions_manager_id) {
              assignedTo = this.record.dispositions_manager_id;
            }
          }
          if (template.user_role === ENUMS.UserRoleEnum.RehabManager.value) {
            if (this.record.rehab_manager_id) {
              assignedTo = this.record.rehab_manager_id;
            }
          }
          if (template.user_role === ENUMS.UserRoleEnum.TransactionCoordinator.value) {
            if (this.record.transaction_coordinator_id) {
              assignedTo = this.record.transaction_coordinator_id;
            }
          }
        }

        this.form = {
          id: this.form.id,
          record_id: this.form.record_id,
          set_due_at: this.form.set_due_at,
          tags: this.form.tags,

          label: template.label,
          description: template.description,
          assigned_to_id: assignedTo,
          is_required_to_change_status: template.is_required_to_change_status,
          link: template.link,
          due_at: dates.getNowJSDate(24 * template.day_offset).toISOString(),
        }
      },
      loadTemplates() {
        this.loadingTemplates = true;
        return api.taskTemplates.all().then((response) => {
          this.templates = response.data;
        }).finally(() => {
          this.loadingTemplates = false;
        })
      },
      loadList() {
        this.loadingList = true
        return api.taskLists.all()
          .then((res) => {
            this.lists = res.data
          })
          .finally(() => this.loadingList = false)
      },
      update() {
        return this.$api.tasks.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Task was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        if (this.taskTab === 'list') {
          if (this.selectedList === null) {
            this.validationErrors = { list_id: 'This field is required.' }
            return
          }

          return api.tasks.attachedListToRecord(this.record.id, this.selectedList.id)
            .then(res => {
              this.$buefy.toast.open({
                message: 'Tasks were created',
                type: 'is-success'
              })
              return res
            })
        }

        return this.$api.tasks.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Task was created',
              type: 'is-success'
            });

            return res;
          })
      },
      delete() {
        return this.$api.tasks.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Task was archived',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.task-body {
  min-height: 515px;
}
.task-list {
  ol {
    padding-left: 1.125rem;
    font-size: .9rem;
  }

  &--body {
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &--heading {
    margin-bottom: 6px;
    letter-spacing: 0.3px;

    span {
      color: rgba(55, 59, 60, 0.7)
    }
  }

  &--desc {
    padding-left: 6px;
    font-size: $size-small;
    color: $dark-grey;
    line-height: 1.35;
  }
}
</style>
